import React, {useContext, useEffect, useState, useMemo, useRef} from 'react';
import { Panel } from 'primereact/panel';
import { Chip } from 'primereact/chip';
import classNames from 'classnames';
import AppContext from '../hooks/AppContext'
import RouteContext from '../hooks/RouteContext'

import { Dropdown } from 'primereact/dropdown';

const Filtros = (props) => {
    
    const {eleicoes, instanciaInfo, localidades, ufs, cargos,  zonasEleitorais, locaisVotacao, 
        localidadeSelecionada, setLocalidadeSelecionadaId, 
        cargoSelecionado, setCargoSelecionadoId , 
        zonaESelecionada, zonaESelecionadaId, setZonaESelecionadaId,
        localVSelecionado, localVSelecionadoId, setLocalVSelecionadoId} = useContext(AppContext)
    const {rotaVotacao, rotaSecoes} = useContext(RouteContext);
    
    const [panelCollapsed, setPanelCollapsed] = useState(false);
    const [renderCollapseButton, setRenderCollapseButton] = useState(false);
    const container = useRef();

    //verifica se uma eleição tem a localidade
    const eleicaoTemLocalidade= (eleicao,localidade) =>{        
        return eleicao?.localidades?.some(
            local => (local === localidade?.sgUe) || (eleicao?.tipoAbrangencia!=="Municipal" && localidade?.isUf)
        );
    }

    //verifica se uma eleição tem a localidade
    const eleicoesTemLocalidadeCargo= (localidade, cargo) =>{
        return eleicoes.some( ele => {            
            return ( eleicaoTemLocalidade(ele,localidade) && ele?.cargos?.includes(cargo?.codigo) )
        })  
    }
         
    //Filtra cargo por eleição e localidade
    const filtroCargo= (value) =>{                
        return( 
            (!localidadeSelecionada || eleicoesTemLocalidadeCargo(localidadeSelecionada,value)) 
        )       
    }

    //Filtra localidade por zona, eleicao, cargo e local de votação
    const filtroLocalidade= (value) =>{
        return(                 
            ( !cargoSelecionado || !rotaVotacao || eleicoesTemLocalidadeCargo(value,cargoSelecionado) ) && 
            ( !zonaESelecionada || !rotaSecoes || zonaESelecionada?.localidades?.some(loc => loc?.sgUe==value?.sgUe) || value?.isUf) && 
            ( !localVSelecionado || !rotaSecoes || (value?.sgUe==localVSelecionado?.sgUeMun) || value?.isUf)
        )       
    }   

    //Filtra zona por local de votação e localidade
    const filtroZe = (value) =>{
        return(             
            (!localidadeSelecionada || value?.localidades?.some(loc => loc?.sgUe==localidadeSelecionada?.sgUe) || localidadeSelecionada?.isUf) && 
            (!localVSelecionado || value?.locais_votacao?.includes(localVSelecionado?.idLocal))            
        )
    }

    //Filtra local de votação por zona e localidade
    const filtroLocalVota = (value) =>{
        return(            
            ( !localidadeSelecionada || (value?.sgUeMun == localidadeSelecionada?.sgUe) || localidadeSelecionada?.isUf) &&
            ( !zonaESelecionada || (value?.nrZona == zonaESelecionada?.nrZona))
        );
    }    

    const cargosFiltados = useMemo(() => {
        if(props?.renderCargo){
            return cargos.filter(filtroCargo)
        }
    },[cargos, localidadeSelecionada]);

    const zonasFiltadas = useMemo(() => {
        if(props?.renderZE){
            return zonasEleitorais.filter(filtroZe)
        }
    },[zonasEleitorais, localidadeSelecionada, localVSelecionado]);
    
    const locaisVotacaoFiltados = useMemo(() => {
        if(props?.renderLocalDeVotacao){         
            return locaisVotacao.filter(filtroLocalVota)
        }
    },[locaisVotacao, localidadeSelecionada, zonaESelecionada]);
    
    const localidadesUfsFiltadas = useMemo(() => {        
        return [...ufs,...localidades].filter(filtroLocalidade)                       

    },[ufs, localidades, cargoSelecionado, zonaESelecionada, localVSelecionado]);

    //processa panel collapse para celular
    useEffect(()=>{
        //panelCollapsed        
        if(cargoSelecionado && localidadeSelecionada){
            setPanelCollapsed(true)
        }
    },[cargoSelecionado, localidadeSelecionada])
    
    //processa o botao de panel collapse
    useEffect(()=>{
        //panelCollapse button render        
        if(cargoSelecionado || localidadeSelecionada || zonaESelecionada || localVSelecionado){
            setRenderCollapseButton(true)
        }else{
            setRenderCollapseButton(false)
        }
    },[cargoSelecionado, localidadeSelecionada, zonaESelecionada, localVSelecionado])

    const selecionaZe = (value) =>{        
        setZonaESelecionadaId(value)        
        //reseta local de votação selecionado quando há uma mudança de zona selecionada
        setLocalVSelecionadoId(undefined)
    }

    //controle de seleção de local de votação apenas quando a zona está selecionada
    const selecionaLocalVota = (value) =>{
        setLocalVSelecionadoId(value)
    }

    const wrapperitem = classNames("filto-item grid")

    const temaContainer = classNames("filtro w-full")

    const temaCollapsedChip = classNames("custom-chip chip-filtro mb-1")

    const temaLabel = classNames("filto-item-label col-1")

    const temaDropDown = classNames("filtro-dropdown col-11")

    return (                                           
        <div ref={container} className={temaContainer}>
            <div className="flex-wrap w-full align-content-start mb-vh">               
                <Panel className="filtro-colapse" header={props?.titulo || "Filtro"} toggleable={renderCollapseButton} collapsed={panelCollapsed} onToggle={(e) => setPanelCollapsed(e.value)}>
                    <div id="filtro-colapse-content" className="bloco-dados bloco-filtro">                                      
                        <div className="filto-item grid">
                            <div className={temaLabel}>
                                <i className="pi pi-home"></i>                                
                            </div>                    
                            <Dropdown className={temaDropDown} optionLabel="nmUe" optionValue="sgUe" 
                            value={localidadeSelecionada?.sgUe} options={localidadesUfsFiltadas} 
                            filter showFilterClear resetFilterOnHide filterBy="nmUe"                             
                            filterPlaceholder="Digite uma localidade para buscar"
                            emptyMessage="verifique os parametros selecionados" 
                            emptyFilterMessage="localidade não encontrada"
                            onChange={(e) => setLocalidadeSelecionadaId(e.value)}                            
                            placeholder="Selecione uma localidade" showClear
                            appendTo={container.current}/>
                        </div>
                        {props?.renderCargo &&
                            <div className={wrapperitem}>
                                <div className={temaLabel}>                          
                                    <i className="pi pi-id-card"></i>                                                                
                                </div>                    
                                <Dropdown className={temaDropDown}  optionLabel="nomeNeutro" optionValue="codigo" 
                                value={cargoSelecionado?.codigo} options={cargosFiltados} 
                                onChange={(e) => setCargoSelecionadoId(e.value)} 
                                placeholder="Selecione um cargo" showClear
                                emptyMessage="verifique os parametros selecionados" 
                                appendTo={container.current}/>                    
                            </div>
                        }
                                        
                        {props?.renderZE &&
                            <div className={wrapperitem}>
                                <div className={temaLabel}>                                                                          
                                    <i className="pi pi-sitemap"></i>                             
                                </div>
                                <Dropdown className={temaDropDown} optionLabel="nrZona" optionValue="nrZona" 
                                value={zonaESelecionada?.nrZona} options={zonasFiltadas} 
                                filter showFilterClear resetFilterOnHide filterBy="nrZona"
                                filterPlaceholder="Digite uma zona para buscar"
                                emptyMessage="verifique os parametros selecionados" 
                                emptyFilterMessage="zona eleitoral não encontrada"
                                onChange={(e) => selecionaZe(e.value)}                               
                                placeholder="Selecione uma zona eleitoral" showClear
                                appendTo={container.current}/>
                            </div> 
                        }
                        
                        {(zonaESelecionada ||  (localidadeSelecionada && !localidadeSelecionada?.isUf)) && props?.renderLocalDeVotacao &&
                            <div className={wrapperitem}>
                                <div className={temaLabel}>
                                    <i className="pi pi-map-marker"></i>                                                            
                                </div>
                                {<Dropdown className={temaDropDown} optionLabel="nmLocal" optionValue="idLocal" 
                                    value={localVSelecionado?.idLocal} options={locaisVotacaoFiltados} 
                                    filter showFilterClear resetFilterOnHide filterBy="nmLocal"
                                    filterPlaceholder="Digite o local de votação para buscar"
                                    emptyMessage="verifique os parametros selecionados" 
                                    emptyFilterMessage="local de votação não encontrado"
                                    onChange={(e) => selecionaLocalVota(e.value)}                                                
                                    placeholder="Selecione um local de votação" showClear
                                    appendTo={container.current}/>   
                                }                                                                             
                            </div>        
                        }
                    </div>
                </Panel>
                
                {panelCollapsed &&
                    <div className="bloco-dados bloco-alt">                      
                        {localidadeSelecionada && localidadeSelecionada?.nmUe &&
                            <Chip key={localidadeSelecionada?.nmUe} className={temaCollapsedChip} label={String(localidadeSelecionada?.nmUe)}/>                         
                        }
                        {props.renderCargo && cargoSelecionado && cargoSelecionado?.nomeNeutro &&
                            <Chip key={cargoSelecionado?.nomeNeutro} className={temaCollapsedChip} label={String(cargoSelecionado?.nomeNeutro)}/>
                        }
                        {props.renderZE && zonaESelecionada && zonaESelecionada?.nrZona &&
                            <Chip key={zonaESelecionada?.nrZona} className={temaCollapsedChip} label={"Zona: "+String(zonaESelecionada?.nrZona)}/>
                        }
                        {props.renderLocalDeVotacao && localVSelecionado && localVSelecionado?.nmLocal &&
                            <Chip key={localVSelecionado?.nmLocal} className={temaCollapsedChip} label={String(localVSelecionado?.nmLocal)}/>
                        }                       
                    </div>
                }
            </div>        
        </div>
    );
}

export default Filtros;                
